import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "./fonts/Fonty_Graphik-Regular.ttf";
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));